import axios from 'axios'
import { apiPath } from '../_utils/api-version'
import { request } from './http-client'
import { IDeliveryZone } from '../_types'

export const getActiveDeliveryZones = (
  params: any,
  useDynamicLanguage = false
) =>
  request.get<{ delivery_zones: IDeliveryZone[] }>(
    apiPath('active-delivery-zones', useDynamicLanguage),
    { params }
  )

export const getIsActiveYandexOrder = (params: any) =>
  request.get('/v1/is-active-yandex-order', { params })

export const createClaims = (data: any) =>
  request.post('/v1/yandex/claims/create', data)

export const calculatePriceYandex = (data: any) =>
  request.post('/v1/yandex/check-price', data)

export const getYandexDeliveryTime = (data: {
  branch_id: string
  client_id: string
  destination: {
    lat: number
    long: number
  }
  origin: {
    lat: number
    long: number
  }
  payment_type: 'cash' | 'card'
  source: string
  total_price: number
}) => {
  return request.post<{
    delivery_time: number
    source: 'yandex' | 'noor'
  }>('/v1/yandex/get-delivery-time', data)
}

export const yandexService = {
  getPlaces: (params: any, region = '71.392727, 42.899664', apikey: string) =>
    axios.get('https://search-maps.yandex.ru/v1/', {
      params: {
        ...params,
        type: 'biz',
        lang: 'ru_RU',
        apikey: apikey,
        results: 5,
        ll: region,
        spn: '6.5,6.5',
        rspn: 1,
      },
    }),
  getGeocode: (params: any) =>
    request.get<any>('/v1/map/geocoder', {
      params: {
        ...params,
        geocode: params.geocode,
        format: 'json',
        lang: 'ru_RU',
        sco: 'latlong',
        results: 5,
        type: 'geo,biz',
        ll: params.region,
        spn: '6.5,6.5',
        uri: params.uri,
        rspn: 1,
      },
    }),
  getSuggest: (params: any, region = '71.392727, 42.899664') =>
    request.get<any>('/v1/map/suggest', {
      params: {
        ...params,
        text: params.text,
        lang: 'ru_RU',
        results: 5,
        types: 'geo,biz',
        ll: region,
        spn: '6.5,6.5',
        attrs: 'uri',
      },
    }),
}

export default yandexService
